import { fromJS } from 'immutable';
import * as constants from './profile-edit-modal-constants';

const initialState = fromJS({
  title: '',
  needsToConfirmAddress: false,
  hasFormattedAddress: false,
  addressToConfirm: {},
  field: '',
  value: '',
  type: '',
  specifiedRoute: '',
  hasTriedToLocate: false,
  isValidAddress: false,
  dialogOpen: false,
  settings: {},
});

export function editFieldModal(state = initialState, action) {
  switch (action.type) {
    case 'EDIT_FIELD_FOR_MODAL':
      return state.merge(action.payload);
    case constants.START_INLINE_EDIT:
      return state.merge(action.payload);
    case constants.START_EDIT:
      return state.merge(Object.assign({ dialogOpen: true }, action.payload));
    case 'EDIT_PROFILE_FIELD_STARTING':
    case 'EDIT_USER_LOCATION_PROFILE_FIELD_STARTING':
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING':
    case 'CLEAR_EDIT_MODAL_STATE':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/profile-edit-modal/profile-edit-modal-reducer.js